import React, { Component } from "react";

import { startup } from "../redux/actions/Session";

import OfflineContainer from "./OfflineContainer";
import OnlineContainer from "./SessionContainer";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import logo from "../assets/logo.png";



class RootContainer extends Component {

    async componentDidMount() {
        this.props.startup();
    }

    render() {
        if (this.props.session) {
            if (this.props.session.loading) {
                return (<div style={{ display: "flex", height: "100vh", justifyContent: "center", alignItems: "center" }}>
                    <img src={logo} width="auto" height={100} alt="" />
                </div>)
            } else if (!this.props.session.loading && this.props.session.user) {
                return <OnlineContainer />
            } else if (!this.props.session.loading && this.props.session.user == null) {
                return <OfflineContainer />
            }
        }
        return (<div style={{ display: "flex", height: "100vh", justifyContent: "center", alignItems: "center" }}>
            <img src={logo} width="auto" height={100} alt="" />
        </div>)
    }
}

const mapStateToProps = state => {
    return { session: state.session, firebase: state.firebase.app };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({ startup }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(RootContainer);
